export var debug=function debug(){if(process.env.NODE_ENV==='development'||process.env.REGION_ENV==='boe'){}};export default undefined;